import { SET_SIDEBAR } from '../Constants/sidebar.constants';

const initalState = {
    isSideBarOpen: false
};

const handleMenu = () => {
    const windowWidth = window.innerWidth;
    const breakpointWidth = 960;
    const isSmallScreen = windowWidth < breakpointWidth;
    if (!isSmallScreen) {
        initalState.isSideBarOpen = true;
    }
};
handleMenu();

export default (state = initalState, action) => {
    switch (action.type) {
        case SET_SIDEBAR:
            return {
                isSideBarOpen: action.data
            };
        default:
            return state;
    }
};
